export const LANDING_TRANSLATIONS: Record<string, string> = {
  '1,254 довольных клиента': '1,254 happy customers',
  '14 мая 2026': '14 May 2026',
  'Почему LOVO': 'Why LOVO',
  'Отзывы': 'Reviews',
  'Доверьте': 'Trust',
  'Доверьте перевозку тем, кому уже доверяют': 'Trust your pet with people others already trust',
  'Доверьте перевозку тем, кому уже': 'Trust your pet with people others already',
  'перевозку': 'your pet with',
  'перевозку тем,': 'your pet with people',
  'тем, кому': 'people others',
  'тем, кому уже': 'others already',
  'кому': 'others',
  'уже': 'already',
  'доверяют': 'trust',
  'Откуда': 'From',
  'Куда': 'To',
  'Искать перевозчика': 'Find a carrier',
  'Найти перевозчика': 'Find a carrier',
  'Перевозка питомца': 'Pet transport',
  'Золотистый ретривер едет в автомобиле': 'Golden retriever travelling by car',
  'Кого везут на LOVO': 'Pets travelling with LOVO',
  'Кого везут на LOVO прямо сейчас': 'Pets travelling with LOVO right now',
  'прямо сейчас': 'right now',
  'Активных заявок:': 'Active requests:',
  'последняя секунду назад': 'latest one a second ago',
  'Все заявки': 'All requests',
  'Какие перевозки можно заказать': 'Available transport services',
  'Просто выберите формат — заявка уйдёт в общую ленту, перевозчики нужного типа сами откликнутся со своими условиями': 'Choose a service type and your request will appear in the feed. Suitable carriers will send their own offers.',
  'Просто выберите формат — заявка уйдёт в общую ленту, перевозчики нужного типа': 'Choose a service type and your request will appear in the feed. Suitable carriers',
  'сами откликнутся со своими условиями': 'will send their own offers',
  'Самый востребованный': 'Most popular',
  'Быстро, но дороже': 'Faster, but costs more',
  'Дополнительная услуга': 'Additional service',
  'Авто': 'Road',
  'перевозка': 'transport',
  'Авиа': 'Flight',
  'курьер': 'courier',
  'Карго': 'Cargo',
  'агенты': 'agents',
  'Встреча': 'Pet',
  'питомца': 'meet-and-greet',
  'Самозанятые исполнители и компании со спецоборудованием (клетки, кондиционер, видеонаблюдение). По России, Европе, СНГ — самый частый и доступный вариант.': 'Independent carriers and companies with specialist equipment such as crates, climate control and video monitoring. The most common and affordable option across Russia, Europe and the CIS.',
  'Самозанятые исполнители и компании со спецоборудованием. По России, Европе и СНГ — самый частый и доступный вариант.': 'Independent carriers and companies with specialist equipment. The most common and affordable option across Russia, Europe and the CIS.',
  'Перевозчик берёт вашего питомца в салон по своему пассажирскому билету. Подходит для собак и кошек любого размера.': 'A courier accompanies your pet in the aircraft cabin on their own passenger ticket. Suitable for cats and dogs of any size.',
  'Перевозчик берёт вашего питомца в салон по своему пассажирскому билету.': 'A courier accompanies your pet in the aircraft cabin on their own passenger ticket.',
  'Подходит для собак и кошек': 'Suitable for cats and dogs',
  'любого размера.': 'of any size.',
  'Лицензированные карго-агенты с международным опытом. Оформляют грузовую авиаперевозку под ключ — контейнер по стандартам IATA, ветдокументы, контракт с авиалинией. Для крупных собак или когда вы летите без питомца.': 'Licensed cargo agents provide end-to-end international air freight, including an IATA crate, veterinary documents and airline arrangements. Ideal for large dogs or unaccompanied pets.',
  'Лицензированные карго-агенты оформляют грузовую авиаперевозку под ключ: контейнер IATA, ветдокументы и контракт с авиалинией.': 'Licensed cargo agents arrange end-to-end air freight, including an IATA crate, veterinary documents and an airline contract.',
  'Лицензированные карго-агенты с международным опытом.': 'Licensed cargo agents with international experience.',
  'Оформляют грузовую авиаперевозку под ключ — контейнер по стандартам IATA, ветдокументы, контракт с авиалинией. Для крупных собак или когда вы летите без питомца.': 'They arrange end-to-end air freight with an IATA crate, veterinary documents and airline contracts. Ideal for large dogs or unaccompanied pets.',
  'Питомец прилетел самолётом или приехал поездом без вас — перевозчик встретит на месте, проверит состояние и довезёт по адресу. Встречаем в аэропорту и на железной дороге.': 'If your pet arrives by plane or train without you, a carrier will meet them, check their condition and deliver them to the destination.',
  'Перевозчик встретит питомца в аэропорту или на вокзале, проверит состояние и довезёт по адресу.': 'A carrier will meet your pet at the airport or railway station, check their condition and deliver them to the destination.',
  'Питомец прилетел самолётом или приехал поездом без вас — перевозчик встретит на месте, проверит состояние и довезёт по адресу. Встречаем в аэропорту': 'If your pet arrives by plane or train without you, a carrier will meet them, check their condition and deliver them to the destination. Available at airports',
  'и на железной дороге.': 'and railway stations.',
  'Встреча питомца с перевозчиком': 'Carrier meeting a pet',
  'Владелица питомца создаёт заявку': 'Pet owner creating a request',
  'Куда чаще всего везут': 'Most popular destinations',
  'Куда чаще всего': 'Most popular',
  'везут': 'destinations',
  'Топ-направления этой недели — выберите свой маршрут или впишите любой другой': 'This week’s top routes. Choose one or enter any other destination.',
  'Собака путешествует по Парижу': 'Dog travelling in Paris',
  'Чем LOVO лучше поиска по соцсетям': 'Why LOVO is better than searching social media',
  'Чем LOVO лучше поиска': 'Why LOVO is better than',
  'по соцсетям': 'searching social media',
  'Главное — спокойствие за животное. Шесть вещей, которых нет, когда ищешь перевозчика по чатам и группам.': 'Peace of mind comes first. Six things social media chats and groups cannot offer.',
  'Все перевозчики в одном месте': 'All carriers in one place',
  'Все перевозчики': 'All carriers',
  'в одном месте': 'in one place',
  'Не нужно мониторить десяток чатов и групп в соцсетях — проверенные перевозчики откликаются на вашу заявку сами. Сравните за минуту по портфолио, трём рейтингам и отзывам других хозяев.': 'No need to monitor dozens of chats and groups. Verified carriers respond to your request, so you can quickly compare portfolios, ratings and reviews.',
  'Видите весь путь': 'Follow the entire journey',
  'Видите': 'Follow',
  'весь путь': 'the entire journey',
  'Перевозчик загружает фото и видео в чат на каждой контрольной точке: загрузка, остановка, ночёвка, доставка. Сидите дома и наблюдаете, как ваш питомец едет.': 'The carrier uploads photos and videos at every checkpoint: pickup, stops, overnight stays and delivery. Follow your pet’s journey from home.',
  'Документы проверены': 'Documents are verified',
  'Документы': 'Documents',
  'проверены': 'verified',
  'Паспорт, права, лицензии и фото портфолио — каждого перевозчика проверяет модератор LOVO. Без верификации откликаться на заявки нельзя.': 'LOVO moderators check every carrier’s ID, driving licence, permits and portfolio. Only verified carriers can send offers.',
  'Без скрытых платежей': 'No hidden fees',
  'Без скрытых': 'No hidden',
  'платежей': 'fees',
  'Платите перевозчику напрямую (наличные, перевод, СБП) — LOVO в платежах не участвует. Никаких удержаний, никаких «эскроу», никаких «подождать 3 дня».': 'Pay the carrier directly by cash or transfer. LOVO does not hold your money and there are no escrow delays.',
  'Модерация LOVO на вашей стороне': 'LOVO support is on your side',
  'Модерация LOVO': 'LOVO support',
  'на вашей стороне': 'is on your side',
  'Перевозчик не вышел на связь, не довёз вовремя, спор о состоянии питомца — модератор LOVO разбирает в течение 24 часов. Помогаем связать стороны, найти срочную замену или добиться возврата средств. С вами от заявки до закрытия сделки.': 'If a carrier goes offline, arrives late or a dispute arises, LOVO reviews the case within 24 hours. We help reconnect both parties, find a replacement or arrange a refund.',
  'Для вас — бесплатно': 'Free for customers',
  'Для вас —': 'For customers',
  'бесплатно': 'free',
  'Поиск перевозчика, отклики, чат, отзывы — всё бесплатно. Платит перевозчик: 5% после состоявшейся сделки. У Авито и Clicktrans берут больше.': 'Search, offers, chat and reviews are free. The carrier pays a 5% fee after a completed job.',
  'Питомец едет с перевозчиком': 'Pet travelling with a carrier',
  'Питомец': 'Pet',
  'Собака': 'Dog',
  'Кошка': 'Cat',
  'Грызун': 'Rodent',
  'Птица': 'Bird',
  'Рептилия': 'Reptile',
  'Переноска для питомца': 'Pet carrier crate',
  'Питомец в аэропорту': 'Pet at the airport',
  'Собака смотрит из окна автомобиля': 'Dog looking out of a car window',
  'Контейнер для перевозки питомца': 'Pet transport crate',
  'Питомец в переноске в аэропорту': 'Pet in a carrier at the airport',
  'Скоро': 'Coming soon',
  'на платформе': 'to LOVO',
  'Скоро на платформе': 'Coming soon to LOVO',
  'Поиск и бронь услуг передержки': 'Search and book pet boarding',
  'GPS-отслеживание перевозки': 'Live GPS transport tracking',
  'GPS-отслеживание перевозки в реальном времени': 'Live GPS transport tracking',
  'в реальном времени': 'in real time',
  'Подпишитесь на новости': 'Subscribe for updates',
  'Мы развиваемся. Обещаем не спамить и присылать только важные новости и обновления!': 'We are growing. No spam, only important news and product updates.',
  'Имя': 'Name',
  'Иван': 'Ivan',
  'Электронная почта': 'Email',
  'Подписаться на рассылку': 'Subscribe',
  'Подписка оформлена': 'You are subscribed',
  'Не удалось оформить подписку': 'Could not subscribe',
  'Три шага — и питомец в пути. От заявки до выбора перевозчика обычно проходит несколько часов.': 'Three steps and your pet is on the way. Finding a carrier usually takes only a few hours.',
  'Создайте заявку': 'Create a request',
  'Маршрут, питомец, даты и пожелания. Регистрация — на последнем шаге, заявка не теряется.': 'Add the route, pet, dates and preferences. Registration is the final step and your request is saved.',
  'Создать заявку': 'Create a request',
  'Выберите перевозчика': 'Choose a carrier',
  'Сравнивайте предложения по цене, рейтингу и фото прошлых перевозок.': 'Compare offers by price, rating and photos from previous trips.',
  'Следите за поездкой': 'Follow the journey',
  'Фото с каждого этапа в чате. После доставки — оплата и взаимный отзыв.': 'Receive photos from every stage in chat. After delivery, complete payment and exchange reviews.',
  'Девушка создаёт заявку на перевозку питомца': 'Customer creating a pet transport request',
  'Корги': 'Corgi',
  'Чат с перевозчиком': 'Chat with the carrier',
  'Оставьте заявку и получите лучшие предложения от профессионалов, одобренных другими владельцами животных!': 'Create a request and receive offers from professionals trusted by other pet owners.',
  'Что говорят о LOVO': 'What people say about LOVO',
  'Реальные отзывы из Яндекс Карт и Google Maps — о сервисе и о конкретных перевозчиках': 'Real reviews from Yandex Maps and Google Maps about LOVO and individual carriers.',
  'Все отзывы на Яндекс Картах': 'All reviews on Yandex Maps',
  'Все отзывы на Google Maps': 'All reviews on Google Maps',
  'Яндекс Карты': 'Yandex Maps',
  'Фильтр отзывов': 'Review filters',
  'О платформе · 247': 'About LOVO · 247',
  'О перевозчиках · 1842': 'About carriers · 1842',
  'Случайная подборка': 'Random selection',
  'Предыдущие отзывы': 'Previous reviews',
  'Следующие отзывы': 'Next reviews',
  'Предыдущее видео': 'Previous video',
  'Следующее видео': 'Next video',
  'Предыдущие видеоотзывы': 'Previous video reviews',
  'Следующие видеоотзывы': 'Next video reviews',
  'Фильтры отзывов': 'Review filters',
  'Рейтинг 4.8 из 5': 'Rated 4.8 out of 5',
  'Воспроизвести видео': 'Play video',
  'Реальные отзывы пользователей LOVO — о сервисе и о конкретных перевозчиках': 'Real LOVO customer reviews about the service and individual carriers',
  'LOVO заметно лучше Авито': 'LOVO is noticeably better than Avito',
  'и telegram-каналов — есть': 'and Telegram channels, with',
  'верификация перевозчиков,': 'verified carriers,',
  'портфолио с фото, отзывы.': 'photo portfolios and reviews.',
  'Чувствуется доверие.': 'It feels trustworthy.',
  'Навигация в подвале': 'Footer navigation',
  'Для заказчиков': 'For customers',
  'Для перевозчиков': 'For carriers',
  'Правила сервиса': 'Service rules',
  'Мы в социальных сетях': 'Follow us',
  'Инстаграм': 'Instagram',
  'Фейсбук': 'Facebook',
  'Телеграм': 'Telegram',
  'Скачать приложение': 'Download the app',
  'Все права защищены': 'All rights reserved',
  'Над сайтом работали': 'Site credits',
  'Политика конфиденциальности': 'Privacy policy',
  'Договор оферты': 'Terms of service',
  'От заказчика': 'From the customer',
  'От перевозчика': 'From the carrier',
  'Поиск и бронь услуг': 'Search and book',
  'передержки': 'pet boarding',
  'сроки уточняются': 'dates to be confirmed',
  'цена по договорённости': 'price by agreement',
  'недавно': 'recently',
  'последняя': 'latest',
  'день': 'day',
  'дня': 'days',
  'дней': 'days',
  'перевозчик': 'carrier',
  'перевозчика': 'carriers',
  'перевозчиков': 'carriers',
  'отклик': 'offer',
  'отклика': 'offers',
  'откликов': 'offers',
  'от 3 000 ₽': 'from ₽3,000',
  'от 15 000 ₽': 'from ₽15,000',
  'от 25 000 ₽': 'from ₽25,000',
  'от 2 500 ₽': 'from ₽2,500',
  'Собака в автомобиле на фоне Эйфелевой башни': 'Dog in a car with the Eiffel Tower in the background',
  'Москва': 'Moscow',
  'Берлин': 'Berlin',
  'СПб': 'St Petersburg',
  'Санкт-': 'St',
  'Петербург': 'Petersburg',
  'Хельсинки': 'Helsinki',
  'Прага': 'Prague',
  'Варшава': 'Warsaw',
  'Будапешт': 'Budapest',
  'Минск': 'Minsk',
  'Франкфурт-на-Майне': 'Frankfurt am Main',
  'Белград': 'Belgrade',
  'Алматы': 'Almaty',
  'Нижний': 'Nizhny',
  'Новгород': 'Novgorod',
  'Кавказская овчарка': 'Caucasian Shepherd',
  'Британская': 'British Shorthair',
  'Йорк': 'Yorkshire Terrier',
  'Мейн-кун': 'Maine Coon',
  'Хаски': 'Husky',
  'Бигль': 'Beagle',
  'Авиакурьер': 'Flight courier',
  'Повышенный спрос': 'High demand',
  'Перевозчик встречает питомца': 'Carrier meeting a pet',
  'Платформа удобная, интуитивно понятно. Откликов на заявку приходит много, выбирать есть из кого. Понравилось что комиссии нет для заказчика — только для исполнителя.': 'The platform is convenient and intuitive. Plenty of offers arrive, so there is a real choice. I also like that customers pay no commission; only carriers do.',
  'Искал перевозчика в Прагу, на других платформах не нашла. На LOVO откликнулось 5 человек за вечер. Удобный сервис для редких направлений.': 'I was looking for a carrier to Prague and found none on other platforms. Five people responded on LOVO in one evening. A useful service for uncommon routes.',
  'Сервис в целом хороший. Хотелось бы видеть онлайн-трекинг авто на карте, а не только фото от перевозчика. Думаю, появится со временем.': 'The service is good overall. I would like live vehicle tracking on a map as well as carrier photos. I expect it will be added over time.',
  'Удобно, что заявка попадает в общую ленту и видна всем перевозчикам нужного типа. Откликов прилично, цены конкурентные.': 'It is convenient that a request enters the shared feed and reaches every suitable carrier. There are plenty of offers and the prices are competitive.',
  'Поддержка LOVO реально отвечает быстро. Был спор по одной перевозке — модератор разобрал за сутки, всё справедливо.': 'LOVO support responds quickly. We had a transport dispute and a moderator resolved it fairly within a day.',
  'Перевозили кота из Москвы в Стамбул. Нашли перевозчика за день, всё прошло гладко. Рекомендую!': 'We transported our cat from Moscow to Istanbul. We found a carrier in one day and everything went smoothly. Recommended!',
  'Очень порадовала прозрачность — видно рейтинг каждого перевозчика, реальные отзывы. Не надо гадать, кому доверить питомца.': 'I really appreciate the transparency: every carrier has a visible rating and genuine reviews. There is no need to guess who to trust with your pet.',
};
